import { IBasicUser } from '../core/models/basic-user.model';
import {
	IDcMetadataResponse,
	IMetadataTag,
} from '../core/models/metadata.model';

export enum HdGraphTypeModel {
	BARLINE = 'barline',
	PIE = 'pie',
	FUNNEL = 'funnel',
	GAUGE_LINEAR = 'gauge_linear',
	GAUGE_CIRCULAR = 'gauge_circular',
	GAUGE_BAR = 'gauge_bar',
	TREEMAP = 'treemap',
	SANKEY = 'sankey',
	SCATTER = 'scatter',
	RANGE = 'range',
	INDICATOR = 'indicator',
}

export enum HdGraphSubTypeModel {
	BAR = 'bar',
	AREA = 'area',
	LINE = 'line',
}

export interface IChart {
	id: number;
	metadata: IDcMetadataResponse;
	type: HdGraphTypeModel;
	sub_type?: HdGraphSubTypeModel;
}

export interface IChartResponse {
	id: number;
	metadata_id?: number;
	code?: string;
	label?: string;
	description?: string;
	icon_id?: number;
	tags?: Array<IMetadataTag>;
	active?: boolean;
	creation_date?: string;
	created_by?: IBasicUser;
	update_date?: string;
	updated_by?: IBasicUser;
	project?: {
		id: number;
		label?: string;
		code?: string;
		icon_id?: number;
	};
	type: HdGraphTypeModel;
	sub_type?: HdGraphSubTypeModel;
}
